import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type SubscriptionUtilisationService from 'teacher-ui-client/services/subscription-utilisation'

export default class ManageRoute extends Route {
  @service
  subscriptionUtilisation!: SubscriptionUtilisationService

  model() {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute
    this.subscriptionUtilisation.showOverCapacityFlash(subscriptionType)
  }
}
